
// 人机随即名字 和图片
// eslint-disable-next-line import/prefer-default-export
export const mechineNameArr = [
  {
    name: '李浩宇', headerImg: require('../assets/imgs/manMachine/1.jpg'), level: 1, K_value: '28',
  },
  {
    name: '张子旭', headerImg: require('../assets/imgs/manMachine/2.jpg'), level: 1, K_value: '28',
  },
  {
    name: '贺子轩', headerImg: require('../assets/imgs/manMachine/3.jpg'), level: 1, K_value: '27',
  },
  {
    name: '黄浩然', headerImg: require('../assets/imgs/manMachine/4.jpg'), level: 1, K_value: '27',
  },
  {
    name: '何雨泽', headerImg: require('../assets/imgs/manMachine/5.jpg'), level: 1, K_value: '27',
  },
  {
    name: '王子涵', headerImg: require('../assets/imgs/manMachine/6.jpg'), level: 2, K_value: '26',
  },
  {
    name: '刘欣怡', headerImg: require('../assets/imgs/manMachine/7.jpg'), level: 2, K_value: '26',
  },
  {
    name: '刘可馨', headerImg: require('../assets/imgs/manMachine/8.jpg'), level: 2, K_value: '25',
  },
  {
    name: '船长妈妈', headerImg: require('../assets/imgs/manMachine/9.jpg'), level: 2, K_value: '25',
  },
  {
    name: '猫猫爱阅读', headerImg: require('../assets/imgs/manMachine/10.jpg'), level: 2, K_value: '25',
  },
  {
    name: '王诗涵', headerImg: require('../assets/imgs/manMachine/11.jpg'), level: 3, K_value: '24',
  },
  {
    name: '柯正宇', headerImg: require('../assets/imgs/manMachine/12.jpg'), level: 3, K_value: '24',
  },
  {
    name: '余青阳', headerImg: require('../assets/imgs/manMachine/13.jpg'), level: 3, K_value: '23',
  },
  {
    name: '王雨辰', headerImg: require('../assets/imgs/manMachine/14.jpg'), level: 3, K_value: '23',
  },
  {
    name: '张思辰', headerImg: require('../assets/imgs/manMachine/15.jpg'), level: 4, K_value: '22',
  },
  {
    name: '李博睿', headerImg: require('../assets/imgs/manMachine/16.jpg'), level: 4, K_value: '22',
  },
  {
    name: '李一轩', headerImg: require('../assets/imgs/manMachine/17.jpg'), level: 4, K_value: '21',
  },
  {
    name: '羽动心情', headerImg: require('../assets/imgs/manMachine/18.jpg'), level: 4, K_value: '21',
  },
  {
    name: 'JACK妈妈', headerImg: require('../assets/imgs/manMachine/19.jpg'), level: 4, K_value: '20',
  },
  {
    name: '吾爱吾洋', headerImg: require('../assets/imgs/manMachine/20.jpg'), level: 4, K_value: '20',
  },
  {
    name: '徐童童', headerImg: require('../assets/imgs/manMachine/21.jpg'), level: 5, K_value: '19',
  },
  {
    name: '杨嘉怡', headerImg: require('../assets/imgs/manMachine/22.jpg'), level: 5, K_value: '19',
  },
  {
    name: '邓楚涵', headerImg: require('../assets/imgs/manMachine/23.jpg'), level: 5, K_value: '19',
  },
  {
    name: '杜瀚宇', headerImg: require('../assets/imgs/manMachine/24.jpg'), level: 5, K_value: '19',
  },
  {
    name: '杜正宇', headerImg: require('../assets/imgs/manMachine/25.jpg'), level: 5, K_value: '19',
  },
  {
    name: '悠悠花艺', headerImg: require('../assets/imgs/manMachine/26.jpg'), level: 5, K_value: '18',
  },
  {
    name: '泡泡鱼', headerImg: require('../assets/imgs/manMachine/27.jpg'), level: 5, K_value: '18',
  },
  {
    name: '天涯比邻', headerImg: require('../assets/imgs/manMachine/28.jpg'), level: 5, K_value: '18',
  },
  {
    name: '天使的翅膀', headerImg: require('../assets/imgs/manMachine/29.jpg'), level: 5, K_value: '18',
  },
  {
    name: '小风筝', headerImg: require('../assets/imgs/manMachine/30.jpg'), level: 5, K_value: '18',
  },
];
